import { Helmet } from "react-helmet-async";

/**
 * Reusable SEO component — sets unique <title>, meta description,
 * canonical URL, and Open Graph tags per page.
 */
export default function Seo({
  title,
  description,
  path = "",
  type = "website",
  image,
}) {
  const canonical = `https://buildwiseai.com${path}`;
  const ogImage = image || "https://buildwiseai.com/og-cover.jpg";
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="BuildWise AI" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
